import axios from "axios";

const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "",
});

export const loginUser = async (data) => {
  return await Api.post(`/v1/login`, data);
};

export const forgotUser = async (data) => {
  return await Api.post(`/v1/forgot-password`, data);
};

export const checkToken = async (token) => {
  return await Api.get(`/v1/verify-token?key=${token}`);
};

export const resetPassword = async (data) => {
  return await Api.post(`/v1/reset-password/`, data);
};
